/* @flow */

import { assertNumber, assertString } from '@braindate/util/lib/assert';

/**
 * Set page in GA and send a pageview
 * @param  {string} page - Page to track
 * @return {undefined}
 */
export function trackGAPage(page: string): void {
  assertString(page, 'page');

  const { ga } = window;

  if (ga) {
    ga('set', 'page', page);
    ga('send', 'pageview');
  }
}

/**
 * Send an event to GA
 * @param  {string} category - Category of the event
 * @param  {string} action - Action of the event
 * @param  {any} [label] - Label of the event
 * @param  {number} [value] - Value of the event
 * @param  {boolean} [nonInteraction] - Whether event is a non-interaction event
 * Ref: https://support.google.com/analytics/answer/1033068#NonInteractionEvents
 * @return {undefined}
 */
export function trackGAEvent(
  category: string,
  action: string,
  label?: any,
  value?: number,
  nonInteraction?: boolean,
): void {
  assertString(category, 'category');
  assertString(action, 'action');

  const event = {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: undefined,
    eventValue: undefined,
    nonInteraction: undefined,
  };

  if (label !== null && label !== undefined) {
    event.eventLabel = label;
  }

  if (value !== null && value !== undefined) {
    assertNumber(value, 'value');

    event.eventValue = value;
  }

  if (typeof nonInteraction === 'boolean') {
    event.nonInteraction = nonInteraction;
  }

  typeof window.ga === 'function' && window.ga('send', event);
}

export function trackGAUserTiming(
  category: string,
  variable: string,
  value: number,
): void {
  assertString(category, 'category');
  assertString(variable, 'variable');
  assertNumber(value, 'value');

  const event = {
    hitType: 'timing',
    timingCategory: category,
    timingVar: variable,
    timingValue: value,
  };

  typeof window.ga === 'function' && window.ga('send', event);
}
